import { SortDirection } from './SortDirection';

export class SortDefinition {
  constructor(public field: string, public direction: SortDirection = SortDirection.Asc) {
  }
}
